import { ReactNode } from "react"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Loader } from "@/shared/ui/loader"
import {
    fetchCommunitySectionsAvailability,
    selectLoyaltyLevelsGate,
    selectRestaurantMenusGate,
} from "../../model"
import type { CommunitySectionAvailabilityKey } from "../../model"

interface SectionGateProps {
    children: ReactNode
    section: CommunitySectionAvailabilityKey
}

const disabledText: Record<CommunitySectionAvailabilityKey, string> = {
    loyalty_levels: "Уровни лояльности для сообщества отключены. Включение выполняет General Admin",
    restaurant_menus: "Управление меню для сообщества недоступно. Обратитесь к General Admin",
}

export const SectionGate = ({ children, section }: SectionGateProps) => {
    const dispatch = useAppDispatch()
    const loyaltyLevelsGate = useAppSelector(selectLoyaltyLevelsGate)
    const restaurantMenusGate = useAppSelector(selectRestaurantMenusGate)
    const gate = section === "loyalty_levels" ? loyaltyLevelsGate : restaurantMenusGate

    if (gate.status === "available") {
        return <>{children}</>
    }

    if (gate.status === "loading") {
        return (
            <div className="w-full flex-1 font-manrope flex items-center justify-center">
                <Loader />
            </div>
        )
    }

    if (gate.status === "disabled") {
        return (
            <div className="w-full flex-1 font-manrope flex items-center justify-center px-6">
                <div className="info_panel max-w-[720px] text-center text-color-base">
                    {disabledText[section]}
                </div>
            </div>
        )
    }

    return (
        <div className="w-full flex-1 font-manrope flex items-center justify-center px-6">
            <div className="info_panel max-w-[720px] flex flex-col items-center gap-4 text-center">
                <div className="text-color-danger">
                    Не удалось получить состояние раздела. Попробуйте обновить.
                </div>
                {gate.reason && (
                    <div className="text-color-base">
                        {gate.reason}
                    </div>
                )}
                <button
                    onClick={() => dispatch(fetchCommunitySectionsAvailability())}
                    className="form_handle_button !w-auto px-6"
                >
                    Повторить
                </button>
            </div>
        </div>
    )
}
